import React from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { Router as RouterProvider } from 'react-router'

import { ApolloProvider } from '@apollo/react-common'

import { App } from '@app/App/App'
import { apolloClient } from '@app/common/apollo/apolloClient'
import { NotificationsProvider } from '@app/common/services/Notifications/NotificationsProvider'
import { history, store } from '@app/common/store'
import { env } from '@app/env'
import { IntlProvider } from '@app/intl/IntlProvider'
import { MobileProvider } from '@app/services/useMobile'

const fetchTranslations = async (locale: string) => {
  const stage = env.INTL_ENV || env.BUILD_ENV

  switch (stage) {
    case 'local': {
      return import('@app/devTranslations').then((module) => {
        return module.devTranslations
      })
    }

    default: {
      const url = new URL(`${env.REACT_APP_TRANSLATIONS_PUBLIC_URL}/lawyer/${locale}.json`)
      return fetch(url, {
        method: 'GET',
        headers: {
          accept: 'application/json'
        }
      }).then((res) => res.json())
    }
  }
}

export function ConnectedApp() {
  return (
    <IntlProvider defaultLocale='de' fetchTranslations={fetchTranslations}>
      <NotificationsProvider>
        <MobileProvider>
          <ApolloProvider client={apolloClient}>
            <ReduxProvider store={store}>
              <RouterProvider history={history}>
                <App />
              </RouterProvider>
            </ReduxProvider>
          </ApolloProvider>
        </MobileProvider>
      </NotificationsProvider>
    </IntlProvider>
  )
}
